import { Suspense } from "react";
import { safeLazy } from "react-safe-lazy";
import ErrorBoundary from "@/components/ErrorBoundary";

const Dashboard = safeLazy(() => import("dashboard/App"));

const DashboardApp = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <Dashboard />
      </Suspense>
    </ErrorBoundary>
  );
};
const Loading = () => <p>Loading2...</p>;

export default DashboardApp;
